function isPropValid(prop) {
  return !{
    ownerState: true,
    as: true
  }[prop];
}
export { isPropValid as default };